import { useFormatAmount } from 'core/hooks/useFormatAmount'
import { useContext } from 'react'
import { StoreTrajectoryContext } from '../../state/store-trajectory-context'

interface RecapSegmentsPieLegendProps {
  data: {
    name: string
    value: number
    fill: string
  }[]
}

const RecapSegmentsPieLegend = ({ data }: RecapSegmentsPieLegendProps) => {
  const { store } = useContext(StoreTrajectoryContext)
  const formatAmount = useFormatAmount()

  return (
    <div className="mg-store-trajectory-recap-segments-legend" data-testid="recap-segments-pie-legend">
      {data.map((item, index) => (
        <div className="mg-store-trajectory-recap-segments-legend-line" key={`${item.name}-${index}`}>
          <div
            className="mg-store-trajectory-recap-segments-legend-line-label vp-caption"
            data-testid={`recap-segments-pie-legend-label-${index}`}
          >
            <span
              className="mg-store-trajectory-recap-segments-legend-line-bullet"
              data-testid={`recap-segments-pie-legend-bullet-${index}`}
              style={{ backgroundColor: item.fill }}
            ></span>
            {item.name}
          </div>
          <div
            className="mg-store-trajectory-recap-segments-legend-line-value vp-body-s"
            data-testid={`recap-segments-pie-legend-value-${index}`}
          >
            {formatAmount(item.value, store.currency)}
          </div>
        </div>
      ))}
    </div>
  )
}

export default RecapSegmentsPieLegend
